import React from 'react';

export default function BlueEnvelopeDriverGuidance() {
  return (
    <div className="max-w-4xl mx-auto bg-white p-8">
      <p className="font-bold text-base mb-4">
        Blue Envelope – Driver Guidance
      </p>

      <p className="mb-2">Information for Drivers Using the Blue Envelope</p>

      <p className="mb-2">
        The Blue Envelope is designed to support clearer communication during stressful situations. Reviewing this information ahead of time may help reduce anxiety and make interactions feel more predictable.
      </p>

      <p className="mb-6">
        Using the Blue Envelope is optional. You may choose whether or not to present it.
      </p>

      <p className="mb-2">During an Interaction</p>

      <p className="mb-1">Keep your hands on the steering wheel until directed otherwise.</p>

      <p className="mb-1">Expect bright lights and loud sounds. These are part of normal procedures.</p>

      <p className="mb-1">When appropriate, make others aware that you have a Blue Envelope.</p>

      <p className="mb-1">Ask for permission before reaching for documents or the envelope.</p>

      <p className="mb-1">Move slowly and follow instructions given during the interaction.</p>

      <p className="mb-1">Remain in your vehicle unless directed otherwise.</p>

      <p className="mb-6">Wait to be told when the interaction is complete.</p>

      <p className="mb-2">During a Stop (Review in Advance)</p>

      <p className="mb-2">
        The following reminders reflect the same information shown on the Blue Envelope. Reviewing them ahead of time may help reduce stress during an interaction and allow caregivers or family members to reinforce expectations.
      </p>

      <p className="mb-1">Hands remain visible until directed otherwise.</p>

      <p className="mb-1">Movement should be slow and only after permission is given.</p>

      <p className="mb-1">The Blue Envelope can be presented when appropriate.</p>

      <p className="mb-1">Instructions may come quickly; taking a moment to pause before responding is okay.</p>

      <p className="mb-4">The interaction continues until you are told it is complete.</p>

      <p className="mb-2">Additional Notes</p>

      <p className="mb-4">
        The Blue Envelope may contain documents or information you choose to share. Its purpose is to support communication during high-stress situations.
      </p>
    </div>
  );
}